export const SUPER_MENU_DROPDOWN_KEY = 'super-menu';
